import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  searchText: undefined,
  searchResults: [],
  searchError: false,
  clearResult: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.RESET_SUGGESTIONS: {
      return Object.assign({}, state, { clearResult: true, searchResults: [], searchError: false });
    }
    case types.SHOW_SUGGESTIONS: {
      return Object.assign({}, state, { clearResult: false });
    }
    case types.REQUEST_SUGGESTIONS: {
      const searchText = action.payload.searchText;
      return Object.assign({}, state, { clearResult: false, isLoading: true, searchText, searchResults: [], searchError: false });
    }
    case types.RECEIVE_SUGGESTIONS: {
      const searchText = action.payload.query;
      const searchResults = (state.clearResult === true) ? [] : action.payload.autoComplete;
      return Object.assign({}, state, { isLoading: false, searchText, searchResults, searchError: false });
    }
    case types.RECEIVE_SUGGESTIONS_ERROR: {
      return Object.assign({}, state, { isLoading: false, searchText: undefined, searchResults: [], searchError: true });
    }
    case types.UPDATE_SUGGESTIONS_FROM_CACHE: {
      const searchText = action.payload.query;
      const searchResults = action.payload.autoComplete;
      return Object.assign({}, state, { isLoading: false, searchText, searchResults, searchError: false });
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./contactUs/reducers/reducer-auto-complete.js